<section id="portfolio-holdings">
  <div class="empty-space"></div>
  <div class="jobs" [dir]="'Direction' | translate">
    <div class="container" data-aos="fade-up" data-aos-duration="1000">
      <div class="section-box">
        <div>
          <span class="section-title" [dir]="'Direction' | translate">
            {{ 'PortfolioHoldings.Title' | translate }}
          </span>
        </div>

        <div class="jobs-inner" *ngIf="loaded">
          <p class="intro-text">
            {{ 'PortfolioHoldings.Intro' | translate }}
          </p>

          <div class="summary-panel">
            <div class="summary-item">
              <span class="summary-label">{{ 'PortfolioHoldings.Total' | translate }}</span>
              <span class="summary-value">{{ totalCount }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">{{ 'PortfolioHoldings.Active' | translate }}</span>
              <span class="summary-value">{{ activeCount }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">{{ 'PortfolioHoldings.Other' | translate }}</span>
              <span class="summary-value">{{ otherCount }}</span>
            </div>
            <div class="summary-item top-holding" *ngIf="topHolding">
              <span class="summary-label">{{ 'PortfolioHoldings.TopHolding' | translate }}</span>
              <span class="summary-value-sm">{{ topHolding.name }}</span>
              <span class="summary-weight">{{ topHolding.weight }}%</span>
            </div>
          </div>

          <div class="toolbar">
            <div class="filter-buttons">
              <button
                *ngFor="let filter of filters"
                type="button"
                class="filter-btn"
                [class.active]="selectedFilter === filter.value"
                (click)="setFilter(filter.value)">
                {{ filter.labelKey | translate }}
              </button>
            </div>
            <div class="search-box">
              <input
                type="text"
                [placeholder]="'PortfolioHoldings.Search' | translate"
                [value]="searchTerm"
                (input)="onSearch($any($event.target).value)" />
            </div>
          </div>

          <div class="holdings-list" *ngIf="filteredHoldings.length; else emptyState">
            <div
              class="holding-row"
              *ngFor="let holding of filteredHoldings; let i = index; trackBy: trackById"
              [class.is-zero]="holding.weight === 0">
              <div class="holding-rank">{{ i + 1 }}</div>
              <div class="holding-body">
                <div class="holding-main">
                  <span class="holding-name">{{ holding.name }}</span>
                  <span class="holding-weight" [class.muted]="holding.weight === 0">
                    {{ holding.weight }}%
                  </span>
                </div>
                <div class="holding-bar" *ngIf="holding.weight > 0">
                  <div class="holding-bar-fill" [style.width.%]="barWidth(holding.weight)"></div>
                </div>
              </div>
            </div>
          </div>

          <ng-template #emptyState>
            <div class="empty-state">
              {{ 'PortfolioHoldings.Empty' | translate }}
            </div>
          </ng-template>

          <p class="footnote">
            {{ 'PortfolioHoldings.Footnote' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
